import { ThemeProvider } from "@material-ui/styles";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./styles/eabw.css";
import { eAbwasserTheme as theme } from "./styles/eAbwasserMuiTheme";
import "./styles/wwv.css";
import WasserbuchView from "./views/WasserbuchView";
import {LOGGED_IN_CONDITION, NOT_LOGGED_IN_CONDITION} from "./utils/SecurityUtils";
import EARoute from "./components/EARoute";
import routes from "./consts/routes.json";
import EmbeddedLoginView from "./views/EmbeddedLoginView";
import EmbeddedRegistrationView from "./views/EmbeddedRegistrationView";
import LoggedInEmbedded from "./views/LoggedInEmbedded";

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename="/eAbwasser">
            <Switch>
                <Route path={"/wasserbuch"} component={WasserbuchView} condition={LOGGED_IN_CONDITION}/>
                <EARoute path={routes.LOGIN_EMBEDDED} component={EmbeddedLoginView} condition={NOT_LOGGED_IN_CONDITION}/>
                <EARoute path={routes.REGISTRATION_EMBEDDED} component={EmbeddedRegistrationView} condition={NOT_LOGGED_IN_CONDITION}/>
                <EARoute path={routes.LOGGED_IN_EMBEDDED} component={LoggedInEmbedded} condition={LOGGED_IN_CONDITION}/>
                <ThemeProvider theme={theme}>
                    <Route path={"/"} component={App} />
                </ThemeProvider>
            </Switch>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
